import ClientCreate from './ClientCreate';
import ClientEditContact from './ClientEditContact';
import ClientEditName from './ClientEditName';
import ClientEditStatus from './ClientEditStatus';
import ClientRemoveContact from './ClientRemoveContact';

const UPDATE_TYPES = {
  'CLIENT_CREATE': {
    title: 'client.ClientDetail.Correspondance.Correspondance.Logs.CreatedOn',
    component: ClientCreate,
  },
  'CLIENT_EDIT_NAME': {
    title: 'client.ClientDetail.Correspondance.Correspondance.Logs.EditName',
    component: ClientEditName,
  },
  'CLIENT_EDIT_STATUS': {
    title: 'client.ClientDetail.Correspondance.Correspondance.Logs.EditStatus',
    component: ClientEditStatus,
  },
  'CLIENT_EDIT_CONTACT': {
    title: 'client.ClientDetail.Correspondance.Correspondance.Logs.EditContact',
    component: ClientEditContact,
  },
  'CLIENT_REMOVE_CONTACT': {
    title: 'client.ClientDetail.Correspondance.Correspondance.Logs.RemoveContact',
    component: ClientRemoveContact,
  },
};

export {
  UPDATE_TYPES,
};
